import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanyChatRoomListClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanyChatRoomListClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class CompanyChatRoomListClient implements ICompanyChatRoomListClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, agentName } = input;

        const params = new URLSearchParams();
        const queryString = params.toString();
        if (agentName) {
            params.append('agent_name', agentName);
        }
        const PATH = `${API_LOCATION_URL}/company/chat_rooms?${queryString}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
